

$(document).ready(function() {

    
    if($("#tableClient").length!=0){
        if($(".cita_serch").length!=0){
            $(".cita_serch").keydown(function(event) { 
                return false;
            });
        
            var picker = new Lightpick({
                lang: 'es',
                field: document.querySelector('.cita_serch'),
                singleDate: true,
                footer:true,
                locale:{
                    buttons: {
                        prev: '<',
                        next: '>',
                        reset: 'limpiar',
                        apply: 'Aceptar'
                      },
                      
                },
                onSelect: function(start, end){
                    var str = '';
                    str += start ? start.format('DD/MM/YYYY') + '-' : '';
                    str += end ? end.format('DD/MM/YYYY') : '...';
                    //console.log(str.split("-"));
                    const dateSe=str.split("-");
                   
                    //console.log(this);
                    const elApp=this.el;
                    serchTable(dateSe[0],6)
                    if(dateSe[0]=='...'){
                        serchTable('',6)
                    }else{

                    }
                    //document.getElementById('result-2').innerHTML = str;
                }
            });

            

            console.log(picker)

        }


        if($(".llamada_serch").length!=0){
            $(".llamada_serch").keydown(function(event) { 
                return false;
            });
        
            var picker = new Lightpick({
                lang: 'es',
                field: document.querySelector('.llamada_serch'),
                singleDate: true,
                footer:true,
                locale:{
                    buttons: {
                        prev: '<',
                        next: '>',
                        reset: 'limpiar',
                        apply: 'Aceptar'
                      },
                      
                },
                onSelect: function(start, end){
                    var str = '';
                    str += start ? start.format('DD/MM/YYYY') + '-' : '';
                    str += end ? end.format('DD/MM/YYYY') : '...';
                    //console.log(str.split("-"));
                    const dateSe=str.split("-");
                   
                    //console.log(this);
                    const elApp=this.el;
                    serchTable(dateSe[0],7)
                    if(dateSe[0]=='...'){
                        serchTable('',7)
                    }else{

                    }
                    //document.getElementById('result-2').innerHTML = str;
                }
            });
        }        
    
    
        
        let tableClient = $("#tableClient").DataTable({
            "ordering": false,
            "order": [[ 3, "desc" ]],
            searching: true,
            paging: true,
            info: true,
            pageLength: 50,
            lengthMenu: [
                [10, 25, 50, 100, 300, 600, -1],
                [10, 25, 50, 100, 300, 600, "Todo"]
            ],
            language: {
                sProcessing: "Procesando...",
                sLengthMenu: "Mostrar _MENU_ registros",
                sZeroRecords: "No se encontraron resultados",
                sEmptyTable: "Ningún dato disponible en esta tabla",
                sInfo:
                    "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                sInfoEmpty:
                    "Mostrando registros del 0 al 0 de un total de 0 registros",
                sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
                sInfoPostFix: "",
                sSearch: "Buscar:",
                sUrl: "",
                sInfoThousands: ",",
                sLoadingRecords: "Cargando...",
                oPaginate: {
                    sFirst: "Primero",
                    sLast: "Último",
                    sNext: '<i class="material-icons">chevron_right</i>',
                    sPrevious: '<i class="material-icons">chevron_left</i>'
                },
                oAria: {
                    sSortAscending:
                        ": Activar para ordenar la columna de manera ascendente",
                    sSortDescending:
                        ": Activar para ordenar la columna de manera descendente"
                }
            }
        });
    
        /**
         * Filter client View
         */
        $("#Contract").on("click", function() {
            const da=this.value==0 ? '':this.value;
            serchTable(da,5)
        });

        $("#type_user").on("change", function() {
            const da=this.value==0 ? '':this.value;
            serchTable(da,4)
        });
    
        $("#cliente_sele").on("click", function() {
            const da=this.value==0 ? '':this.value;
            serchTable(da,6)
        });
        //end Filter view
    
    
        /**
         * Filter Prospects View
         */
        $("#selec_sectors").on("click", function() {
            const da=this.value==0 ? '':this.value;
            serchTable(da,4)
    
        });
    
        $("#selec_estado").on("click", function() {
            const da=this.value==0 ? '':this.value;
            serchTable(da,5)
        });
        
        //end Prospects view
    
        
        function serchTable(src,ind) {
            tableClient
            .columns(ind)
            .search(src)
            .draw();
        }
    
        function removeText(labletext) {
            for (const key in labletext) {
                if (labletext.hasOwnProperty(key)) {
                    const element = labletext[key];
                    if (element.nodeName == "#text") {
                        $(element).remove();
                    }
                }
            }
        }
        setTimeout(() => {
            /**
             * Select serch registros
             */
    
            //se ocultan elementos propios de datatable para select
            $("#tableClient_length > label > div > input")
                .attr("type", "hidden")
                .css("display", "none");
            $("#tableClient_length > label > div > svg").css("display", "none");
    
            $("#tableClient_length > label > div > select").addClass(
                "browser-default"
            );
    
            //seagrega imagen para el select
            $("<img>")
                .addClass("arrow_select")
                .attr("src", https+"img/arrow_select.svg")
                .appendTo($("#tableClient_length > label > div"));
            $("#tableClient_length")
                .addClass("container-select row")
                .css({
                    "margin-bottom": 0,
                    "border-bottom": "none",
                    "padding-bottom": 0
                })
                .removeClass("dataTables_length");
    
            /**
             * input serch
             */
            $("#tableClient_filter").addClass("container-serBus");
            const inpuDa = $("#tableClient_filter > label > input[type=search]")
                .addClass("browser-default")
                .attr("placeholder", "Busqueda global");
            $("<div>").append(inpuDa);
            const labelSerc = $("#tableClient_filter > label").addClass(
                "valign-wrapper"
            );
    
            $("<i>")
                .addClass("material-icons")
                .text("search")
                .appendTo(labelSerc);
    
            labelSerc.append(inpuDa);
            removeText(labelSerc[0].childNodes); //eliminado TextNode, propios de dataTable
            $("#tableClient_length > label > div").addClass(
                "select-wrapper col l2 select"
            );
            const labletext = $("#tableClient_length > label");
            removeText(labletext[0].childNodes); //eliminado TextNode, propios de dataTable
    
            $("#tableClient_paginate").addClass("valign-wrapper on_paginate");
    
            $("#tableClient_paginate > span > a").click(function() {});
        }, 10);        
    }

});
